import { useMemo as R } from "react";
import { DOTS as s } from "./pagintaionHeplers.js";
const c = (e, a) => {
  const t = a - e + 1;
  return Array.from({ length: t }, (r, i) => i + e);
}, M = ({
  totalCount: e,
  pageSize: a,
  siblingCount: t = 1,
  currentPage: r
}) => R(() => {
  const n = Math.ceil(e / a);
  if (t + 5 >= n)
    return c(1, n);
  const m = Math.max(r - t, 1), h = Math.min(
    r + t,
    n
  ), g = m > 2, f = h < n - 2, l = 1, u = n;
  if (!g && f) {
    const o = 3 + 2 * t;
    return [...c(1, o), s, n];
  }
  if (g && !f) {
    const o = 3 + 2 * t, d = c(
      n - o + 1,
      n
    );
    return [l, s, ...d];
  }
  if (g && f) {
    const o = c(m, h);
    return [l, s, ...o, s, u];
  }
}, [e, a, t, r]);
export {
  M as usePagination
};
